import { Flex, Text, WrapItem, Icon } from '@chakra-ui/react';
import { RiCheckboxIndeterminateFill } from 'react-icons/ri';
import {removeSelectedSkill} from '../utils';

const Skill = ({ props, qObj, skill, style, skillCounter }) => {
  return (
    <WrapItem>
      <Flex sx={{ ...style.skillsBox.wrapped.flex }}>
        <Text key={skillCounter} sx={{ ...style.skillsBox.wrapped.flex.text }}>
          {skill}
        </Text>
        <Icon
          onClick={() => removeSelectedSkill(props,  qObj.qid, skill)}
          as={RiCheckboxIndeterminateFill}
          // this styling must remain here // design flaw of chakra ui
          sx={{
            marginTop: '4px',
            marginLeft: '4px',
            marginRight: '-2px',
            color: 'WHITE',
            cursor: 'pointer'
          }}
        />
      </Flex>
    </WrapItem>
  );
};
export default Skill;
